<template>
  <div class="relative-pull mt-10" v-loading="loading">
    <div v-if="code == 'pdfOpera'">
      <el-main class="user-pdf">
        <!-- <div v-for="(item, index) in pdfurl" :key="index">
          <pdf ref="pdf" v-for="i in item.pdfinfo['numPages']" :key="i" :src="item.pdfinfo['src']" :page="i"></pdf>
        </div> -->
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(item, index) in pdfurl" :key="index" :label="item.title" :name="item.active">
            <pdf ref="pdf" v-for="i in item.pdfinfo['numPages']" :key="i" :src="item.pdfinfo['src']" :page="i"></pdf>
          </el-tab-pane>
        </el-tabs>
        <!--<el-empty v-if="data == 'none'" description="无相关手册"></el-empty>
        <pdfh5 :url="filePathFormat(data.FilePaths)" v-else></pdfh5> -->
      </el-main>
    </div>
  </div>
</template>

<script>
  import pdf from "vue-pdf";
  import * as indexService from "@/api/sys/index";
  export default {
    name: "pdfOpera",
    components: {
      pdf,
    },
    data() {
      return {
        loading: false,
        pdfurl: [],
        numPages: 1,
        activeName: 0,
      };
    },
    props: {
      code: {
        type: String,
        required: false,
        default: "",
      },
      content: {
        type: String,
        required: false,
        default: "",
      },
      menu: {
        type: Array,
        required: false,
        default: () => [],
      },
      name: {
        type: String,
        required: false,
        default: "",
      },
      checked: {
        type: Object,
        required: false,
        default: {},
      },
    },
    mounted() {},
    computed: {
      unitname() {
        return this.$store.state.d2admin.userInfo.userinfo;
      },
    },
    created() {
      this.pdfurl = [];
      if (this.code == "pdfOpera") {
        let pdfList = []
        if (this.content != '') pdfList = JSON.parse(this.content);
        pdfList.map((v, index) => {
          this.pdfurl.push({
            title: v.Title,
            active: index + "",
            pdfinfo: {
              src: v.FilePaths,
              numPages: 1
            }
          });
          this.handelPdf1(this.pdfurl[index].pdfinfo);
        });
      }
    },
    watch: {
      content(val) {
        this.pdfurl = [];
        if (this.code == "pdfOpera") {
          let pdfList = []
          if (val != '') pdfList = JSON.parse(val);
          pdfList.map((v, index) => {
            this.pdfurl.push({
              title: v.Title,
              active: index + "",
              pdfinfo: {
                src: v.FilePaths,
                numPages: 1
              }
            });
            this.handelPdf1(this.pdfurl[index].pdfinfo);
          });
        }
      },
    },
    methods: {
       handelPdf1(item) {
        setTimeout(async () => {
          item.numPages = await pdf.createLoadingTask(item.src).promise.then((pdf) => {
            return pdf.numPages;
          });
        }, 500);
        // this.$nextTick(()=>{

        // })
      },
      handleClick(tab, event) {},
    },
    beforeDestroy() {
      // 销毁
      console.log('shishi')
    },
    destroyed() {
      console.log('shishi')
    }
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/style.css";
  @import "~@/assets/style/richText.scss";

  /deep/.el-main {
    padding: 0;
  }

  .no-data {
    height: 500px;
    line-height: 500px;
    text-align: center;
    color: #606266;
  }

  .user-pdf {
    position: relative;
  }

  .pdf-name {
    position: absolute;
    left: 75px;
    display: block;
    width: 300px;
    height: 60px;
    line-height: 60px;
    background-color: #323639;
    color: #ffffff;
    font-weight: bold;
  }
</style>